import apiClient from '../utils/apiClient';

class OTPService {
    async sendOTPSelf(loginId) {
        const response = await apiClient.post('/otp/send-self', { loginId });
        return response;
    }

    async verifyOTPSelf(loginId, otp) {
        const response = await apiClient.post('/otp/verify-self', { loginId, otp });
        return response;
    }
}

const otpService = new OTPService();
export default otpService;
